// Replaceable image slot. Renders the real image once `src` is provided.
// fit="contain" is used for product photography (square white surface, no
// cropping, centered) so bracelets and charms are never stretched or clipped.
// fit="cover" is used for editorial/lifestyle imagery. The fixed-aspect wrapper
// reserves layout space to avoid content shift while images load.
export const ImageSlot = ({
  name,
  label,
  src,
  alt,
  ratio = "aspect-[4/5]",
  className = "",
  imgClassName = "",
  fit = "cover",
  surface,
  priority = false,
}) => {
  const bg = surface || (fit === "contain" ? "bg-white" : "bg-brand-sand/40");
  const loading = priority ? "eager" : "lazy";

  if (src) {
    if (fit === "contain") {
      return (
        <div className={`relative ${ratio} overflow-hidden ${bg} ${className}`} data-image-slot={name}>
          <img
            src={src}
            alt={alt || label}
            loading={loading}
            decoding="async"
            className={`h-full w-full object-contain object-center ${imgClassName}`}
          />
        </div>
      );
    }
    return (
      <div className={`relative ${ratio} overflow-hidden ${bg} ${className}`} data-image-slot={name}>
        <img
          src={src}
          alt={alt || label}
          loading={loading}
          decoding="async"
          className={`absolute inset-0 h-full w-full object-cover ${imgClassName}`}
        />
      </div>
    );
  }

  return (
    <div
      className={`relative ${ratio} overflow-hidden border border-brand-sand bg-brand-surface ${className}`}
      data-image-slot={name}
      role="img"
      aria-label={alt || label}
    >
      <img
        src="/brand/product-placeholder.svg"
        alt={alt || `${label} — HESHAURA photograph coming soon`}
        loading={loading}
        decoding="async"
        className={`absolute inset-0 h-full w-full object-cover ${imgClassName}`}
      />
    </div>
  );
};
